import { isEmptyString } from "../../../utils/Functions";

export const PHONE_NUMBER_MIN_LENGTH = 8;
export const PHONE_NUMBER_MAX_LENGTH = 17;

function isMobilePhone(phoneNumber) {
  if (isEmptyString(phoneNumber)) return false;
  return (
    phoneNumber.length >= PHONE_NUMBER_MIN_LENGTH &&
    phoneNumber.length <= PHONE_NUMBER_MAX_LENGTH
  );
}

export { isMobilePhone };
